import { Instagram, Mail, MapPin, Phone, Youtube } from "lucide-react";
import { motion } from "framer-motion";

const footerLinks = [
  { label: "Home", href: "/" },
  { label: "About", href: "/About_us" },
  { label: "Services", href: "/Get_Start" },
  { label: "Events", href: "/Events" },
  { label: "Contact", href: "/contact_us" },
];

const Footer = () => {
  return (
    <footer className="ym-footer">
      <div className="ym-footer-main">
        <div className="ym-footer-grid">
          <motion.div initial={{ opacity: 0, y: 18 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
            <div className="ym-brand" style={{ color: "#fff" }}>
              <img src="/yogamaticicon.jpg" className="ym-logo" alt="YogaMatic" />
              <span className="ym-brand-text">
                <strong>YogaMatic</strong>
                <span style={{ color: "rgba(255,255,255,0.62)" }}>Practice with purpose</span>
              </span>
            </div>
            <p className="ym-text" style={{ color: "rgba(255,255,255,0.72)", marginTop: 18, maxWidth: 360 }}>
              Premium yoga sessions, demos, and wellness events in Jaipur with thoughtful guidance for every level.
            </p>
            <div className="ym-social-row" style={{ marginTop: 20 }}>
              <a href="https://www.instagram.com/yogamatic.in/" target="_blank" rel="noreferrer" aria-label="Instagram">
                <Instagram size={18} />
              </a>
              <a href="https://www.youtube.com/@YOGAMATIC." target="_blank" rel="noreferrer" aria-label="YouTube">
                <Youtube size={19} />
              </a>
            </div>
          </motion.div>

          <motion.nav
            initial={{ opacity: 0, y: 18 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.05 }}
            aria-label="Footer navigation"
          >
            <h3 style={{ margin: "0 0 16px", color: "#fff", fontSize: 18, fontWeight: 850 }}>Explore</h3>
            <ul className="ym-footer-link-list">
              {footerLinks.map((link) => (
                <li key={link.href}>
                  <a href={link.href}>{link.label}</a>
                </li>
              ))}
            </ul>
          </motion.nav>

          <motion.div
            initial={{ opacity: 0, y: 18 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
          >
            <h3 style={{ margin: "0 0 16px", color: "#fff", fontSize: 18, fontWeight: 850 }}>Visit Us</h3>
            <div className="ym-check-list" style={{ marginTop: 0 }}>
              <div style={{ display: "flex", gap: 10, color: "rgba(255,255,255,0.76)", lineHeight: 1.6 }}>
                <MapPin size={18} style={{ flex: "0 0 auto", marginTop: 4, color: "var(--ym-gold)" }} />
                <span>Mahaveer Nagar Y, 80 ft road Sanganer, Jaipur 302029</span>
              </div>
              <div style={{ display: "flex", gap: 10, color: "rgba(255,255,255,0.76)", lineHeight: 1.6 }}>
                <Phone size={18} style={{ flex: "0 0 auto", marginTop: 4, color: "var(--ym-gold)" }} />
                <a href="tel:+919828381188">+91 9828381188</a>
              </div>
              <div style={{ display: "flex", gap: 10, color: "rgba(255,255,255,0.76)", lineHeight: 1.6 }}>
                <Mail size={18} style={{ flex: "0 0 auto", marginTop: 4, color: "var(--ym-gold)" }} />
                <a href="mailto:yogawithajaynama@gmail.com">yogawithajaynama@gmail.com</a>
              </div>
            </div>
          </motion.div>
        </div>

        <div
          style={{
            marginTop: 36,
            paddingTop: 22,
            borderTop: "1px solid rgba(255,255,255,0.14)",
            color: "rgba(255,255,255,0.58)",
            fontSize: 14,
            textAlign: "center",
          }}
        >
          Copyright {new Date().getFullYear()} YogaMatic. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
